"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleScrollShadows = exports.calcStickyProperties = void 0;
const util_1 = require("@app/util");
const calcStickyProperties = (cellIndex, rowColumns = []) => {
    const previousCell = cellIndex > 0 ? rowColumns[cellIndex - 1] : undefined;
    const isPreviousSticky = previousCell?.sticky;
    const nextCell = rowColumns[cellIndex + 1];
    const isNextSticky = nextCell?.sticky;
    // @ts-expect-error idk it works
    const isPreviousSelection = previousCell?.id === 'selection';
    const isLast = rowColumns?.length === cellIndex + 1;
    const stickyOffset = () => {
        if (isPreviousSticky || isPreviousSelection) {
            return rowColumns.slice(0, cellIndex).reduce((acc, curr) => {
                return acc + (Number(curr.width) ?? 0);
            }, 0);
        }
    };
    return {
        isLast,
        previousCell,
        isPreviousSticky,
        isNextSticky,
        stickyOffset: stickyOffset(),
    };
};
exports.calcStickyProperties = calcStickyProperties;
const handleScrollShadows = (e, tableRef) => {
    const target = e.target;
    const table = tableRef.current;
    if (!(target instanceof Element))
        return;
    if (!(0, util_1.isValue)(table))
        return;
    if (target.scrollLeft > 0) {
        const selectors = table.querySelectorAll('.with-shadow-detection');
        selectors.forEach((selector) => selector.classList.add('with-shadow'));
    }
    else {
        const selectors = table.querySelectorAll('.with-shadow-detection');
        selectors.forEach((selector) => selector.classList.remove('with-shadow'));
    }
    if (target.scrollWidth - target.scrollLeft - target.getBoundingClientRect().width >
        0) {
        const selectors = table.querySelectorAll('.last-sticky-detection');
        selectors.forEach((selector) => selector.classList.add('last-sticky'));
    }
    else {
        const selectors = table.querySelectorAll('.last-sticky-detection');
        selectors.forEach((selector) => selector.classList.remove('last-sticky'));
    }
};
exports.handleScrollShadows = handleScrollShadows;
